import { createActionCreator } from '@pressreader/appstore';
import { IssueLayout } from '@pressreader/content-types';

import { MODULE_NAME } from '../../../constants';

const pre = `${MODULE_NAME}/issues/layout/`;

export const loadIssueLayoutBeganEvent = createActionCreator<{ cidDateKey: string }>(`${pre}load_issue_layout_began`);
export const loadIssueLayoutDoneEvent = createActionCreator<{ cidDateKey: string; layout: IssueLayout }>(`${pre}load_issue_layout_done`);
export const loadIssueLayoutFailedEvent = createActionCreator<{ cidDateKey: string }>(`${pre}load_issue_layout_failed`);
